export const get = state => state.urlAuth
